import React from 'react';
import { theme } from '../utils/constants';
import toast from 'react-hot-toast';

export default function ProductCard({ product, addToCart, navigateTo }) {
  return (
    <>
      <div
        style={{
          background: theme.surface,
          borderRadius: '14px',
          overflow: 'hidden',
          boxShadow: theme.shadowSm,
          transition: 'all 0.32s ease',
          border: `1px solid ${theme.border}`,
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-10px)';
          e.currentTarget.style.boxShadow = theme.shadowMd;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = theme.shadowSm;
        }}
      >
        {/* Product Image */}
        <div
          style={{
            height: '360px',
            overflow: 'hidden'
          }}
        >
          <img
            src={product.image}
            alt={product.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform .5s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.07)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
            }}
          />
        </div>

        <div
          style={{
            padding: '1.7rem',
            display: 'flex',
            flexDirection: 'column',
            flex: 1
          }}
        >
          <h3
            style={{
              fontSize: '1.28rem',
              margin: '0 0 .6rem',
              fontWeight: 600,
              color: '#111',
              textAlign: 'center',
              lineHeight: 1.4
            }}
          >
            {product.title}
          </h3>

          <p
            style={{
              color: theme.textLight,
              fontSize: '.92rem',
              textAlign: 'center',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              margin: '0'
            }}
          >
            {product.author}
          </p>

          {/* Price */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              margin: '1.4rem 0 1.8rem'
            }}
          >
            <span
              style={{
                background: theme.primary,
                color: '#fff',
                padding: '6px 10px',
                borderRadius: '8px',
                fontSize: '.72rem',
                fontWeight: 700,
                letterSpacing: '1px'
              }}
            >
              ZMK
            </span>

            <span
              style={{
                fontSize: '2.15rem',
                fontWeight: 800,
                color: theme.primary,
                lineHeight: 1
              }}
            >
              {product.price.toFixed(2)}
            </span>
          </div>

          <div style={{ marginTop: 'auto' }}>
            <div className="product-buttons">
              <button
                onClick={() => navigateTo('product-detail', product)}
                style={{
                  flex: 1,
                  background: '#fff',
                  border: `2px solid ${theme.primary}`,
                  color: theme.primary,
                  padding: '.95rem',
                  borderRadius: '50px',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                Details
              </button>

              <button
                // onClick={() => addToCart(product)}
                onClick={() => {
                  addToCart(product);

                  toast.success(`${product.title} added to cart`);
                }}
                style={{
                  flex: 1,
                  background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
                  color: '#111',
                  border: 'none',
                  padding: '.95rem',
                  borderRadius: '50px',
                  fontWeight: 700,
                  cursor: 'pointer'
                }}
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .product-buttons {
          display: flex;
          gap: 12px;
        }

        @media (max-width: 640px) {
          .product-buttons {
            flex-direction: column;
          }
        }
      `}</style>
    </>
  );
}
// // src/components/ProductCard.jsx
// import React from 'react';
// import { theme } from '../utils/constants';

// export default function ProductCard({ product, addToCart, navigateTo }) {
//   return (
//     <>
//       <div
//         style={{
//           background: theme.surface,
//           borderRadius: '14px',
//           overflow: 'hidden',
//           boxShadow: theme.shadowSm,
//           transition: 'all 0.32s ease',
//           border: `1px solid ${theme.border}`,
//           height: '100%',
//           minWidth: '340px',
//           display: 'flex',
//           flexDirection: 'column'
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.transform = 'translateY(-10px)';
//           e.currentTarget.style.boxShadow = theme.shadowMd;
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.transform = 'translateY(0)';
//           e.currentTarget.style.boxShadow = theme.shadowSm;
//         }}
//       >
//         {/* Product Image */}
//         <div
//           style={{
//             height: '360px',
//             overflow: 'hidden'
//           }}
//         >
//           <img
//             src={product.image}
//             alt={product.title}
//             style={{
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//               transition: 'transform .5s ease'
//             }}
//             onMouseEnter={(e) => {
//               e.target.style.transform = 'scale(1.07)';
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.transform = 'scale(1)';
//             }}
//           />
//         </div>

//         {/* Card Content */}
//         <div
//           style={{
//             padding: '1.7rem',
//             display: 'flex',
//             flexDirection: 'column',
//             flex: 1
//           }}
//         >
//           {/* Product Title */}
//           <h3
//             style={{
//               fontSize: '1.28rem',
//               margin: '0 0 .6rem',
//               fontWeight: 600,
//               color: '#111',
//               textAlign: 'center',
//               lineHeight: 1.4
//             }}
//           >
//             {product.title}
//           </h3>

//           {/* Collection */}
//           <p
//             style={{
//               color: theme.textLight,
//               fontSize: '.92rem',
//               textAlign: 'center',
//               textTransform: 'uppercase',
//               letterSpacing: '1px',
//               margin: '0'
//             }}
//           >
//             {product.author}
//           </p>

//           {/* Price */}
//           <div
//             style={{
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               gap: '10px',
//               margin: '1.4rem 0 1.8rem'
//             }}
//           >
//             <span
//               style={{
//                 background: theme.primary,
//                 color: '#fff',
//                 padding: '6px 10px',
//                 borderRadius: '8px',
//                 fontSize: '.72rem',
//                 fontWeight: 700,
//                 letterSpacing: '1px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               ZMK
//             </span>

//             <span
//               style={{
//                 fontSize: '2.15rem',
//                 fontWeight: 800,
//                 color: theme.primary,
//                 lineHeight: 1
//               }}
//             >
//               {product.price.toFixed(2)}
//             </span>
//           </div>

//           {/* Push buttons to bottom */}
//           <div style={{ marginTop: 'auto' }}>
//             <div className="product-buttons">
//               <button
//                 onClick={() => {
//                   console.log(
//                     'Navigating to product detail for:',
//                     product
//                   );
//                   navigateTo('product-detail', product);
//                 }}
//                 style={{
//                   flex: 1,
//                   background: '#fff',
//                   border: `2px solid ${theme.primary}`,
//                   color: theme.primary,
//                   padding: '.95rem',
//                   borderRadius: '50px',
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                   transition: 'all .25s ease'
//                 }}
//               >
//                 Details
//               </button>

//               <button
//                 onClick={() => addToCart(product)}
//                 style={{
//                   flex: 1,
//                   background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
//                   color: '#111',
//                   border: 'none',
//                   padding: '.95rem',
//                   borderRadius: '50px',
//                   fontWeight: 700,
//                   cursor: 'pointer',
//                   transition: 'all .25s ease'
//                 }}
//               >
//                 Add to Cart
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .product-buttons {
//           display: flex;
//           gap: 12px;
//         }

//         @media (max-width: 768px) {
//           .product-buttons {
//             flex-direction: column;
//           }
//         }

//         @media (max-width: 420px) {
//           div[style] {
//             min-width: 100% !important;
//           }
//         }
//       `}</style>
//     </>
//   );
// }
// // src/components/ProductCard.jsx
// import React from 'react';
// import { theme } from '../utils/constants';

// export default function ProductCard({ product, addToCart, navigateTo }) {
//   return (
//     <>
//       <div
//         style={{
//           background: theme.surface,
//           borderRadius: '12px',
//           overflow: 'hidden',
//           boxShadow: theme.shadowSm,
//           transition: 'all 0.32s ease',
//           border: `1px solid ${theme.border}`,
//           height: '100%',
//           display: 'flex',
//           flexDirection: 'column'
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.transform = 'translateY(-10px)';
//           e.currentTarget.style.boxShadow = theme.shadowMd;
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.transform = 'translateY(0)';
//           e.currentTarget.style.boxShadow = theme.shadowSm;
//         }}
//       >
//         {/* Product Image */}
//         <div style={{ height: '320px', overflow: 'hidden' }}>
//           <img
//             src={product.image}
//             alt={product.title}
//             style={{
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//               transition: 'transform 0.5s ease'
//             }}
//             onMouseEnter={(e) => (e.target.style.transform = 'scale(1.07)')}
//             onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
//           />
//         </div>

//         {/* Content */}
//         <div
//           style={{
//             padding: '1.6rem',
//             display: 'flex',
//             flexDirection: 'column',
//             flex: 1
//           }}
//         >
//           <h3
//             style={{
//               fontSize: '1.25rem',
//               margin: '0 0 .5rem',
//               fontWeight: 600,
//               color: '#111'
//             }}
//           >
//             {product.title}
//           </h3>

//           <p
//             style={{
//               color: theme.textLight,
//               fontSize: '.95rem',
//               margin: '0 0 1rem'
//             }}
//           >
//             {product.author}
//           </p>

//           {/* Better Price */}
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'baseline',
//               gap: '8px',
//               marginBottom: '1.5rem'
//             }}
//           >
//             <span
//               style={{
//                 background: theme.primary,
//                 color: '#fff',
//                 padding: '4px 8px',
//                 borderRadius: '6px',
//                 fontSize: '.72rem',
//                 fontWeight: 700,
//                 letterSpacing: '1px'
//               }}
//             >
//               ZMK
//             </span>

//             <span
//               style={{
//                 fontSize: '2rem',
//                 fontWeight: 800,
//                 color: theme.primary,
//                 lineHeight: 1
//               }}
//             >
//               {product.price.toFixed(2)}
//             </span>
//           </div>

//           {/* Push buttons to bottom */}
//           <div style={{ marginTop: 'auto' }}>
//             <div className="product-buttons">
//               <button
//                 onClick={() => {
//                   console.log(
//                     'Navigating to product detail for:',
//                     product
//                   );
//                   navigateTo('product-detail', product);
//                 }}
//                 style={{
//                   flex: 1,
//                   background: '#fff',
//                   border: `2px solid ${theme.primary}`,
//                   color: theme.primary,
//                   padding: '.9rem',
//                   borderRadius: '50px',
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                   transition: 'all .25s ease'
//                 }}
//               >
//                 Details
//               </button>

//               <button
//                 onClick={() => addToCart(product)}
//                 style={{
//                   flex: 1,
//                   background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
//                   color: '#111',
//                   border: 'none',
//                   padding: '.9rem',
//                   borderRadius: '50px',
//                   fontWeight: 700,
//                   cursor: 'pointer',
//                   transition: 'all .25s ease'
//                 }}
//               >
//                 Add to Cart
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .product-buttons {
//           display: flex;
//           gap: 12px;
//         }

//         @media (max-width: 640px) {
//           .product-buttons {
//             flex-direction: column;
//           }
//         }
//       `}</style>
//     </>
//   );
// }
// // src/components/ProductCard.jsx
// import React from 'react';
// import { theme } from '../utils/constants';

// export default function ProductCard({ product, addToCart, navigateTo }) {
//   return (
//     <div
//       style={{
//         background: theme.surface,
//         borderRadius: '12px',
//         overflow: 'hidden',
//         boxShadow: theme.shadowSm,
//         transition: 'all 0.32s ease',
//         border: `1px solid ${theme.border}`
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = 'translateY(-10px)';
//         e.currentTarget.style.boxShadow = theme.shadowMd;
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = 'translateY(0)';
//         e.currentTarget.style.boxShadow = theme.shadowSm;
//       }}
//     >
//       <div style={{ height: '320px', overflow: 'hidden' }}>
//         <img
//           src={product.image}
//           alt={product.title}
//           style={{
//             width: '100%',
//             height: '100%',
//             objectFit: 'cover',
//             transition: 'transform 0.5s ease'
//           }}
//           onMouseEnter={(e) => (e.target.style.transform = 'scale(1.07)')}
//           onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
//         />
//       </div>

//       <div style={{ padding: '1.6rem' }}>
//         <h3
//           style={{
//             fontSize: '1.28rem',
//             margin: '0 0 0.5rem',
//             fontWeight: 600
//           }}
//         >
//           {product.title}
//         </h3>

//         <p
//           style={{
//             color: theme.textLight,
//             fontSize: '0.96rem',
//             margin: '0 0 0.8rem'
//           }}
//         >
//           {product.author}
//         </p>

//         <p
//           style={{
//             fontSize: '1.42rem',
//             fontWeight: 700,
//             color: theme.primary,
//             margin: '0 0 1.2rem'
//           }}
//         >
//           zmk {product.price.toFixed(2)}
//         </p>

//         <div style={{ display: 'flex', gap: '12px' }}>
//           <button
//             onClick={() => {
//               console.log("Navigating to product detail for:", product);
//               navigateTo('product-detail', product)}}
//             style={{
//               flex: 1,
//               background: 'transparent',
//               border: `2px solid ${theme.primary}`,
//               color: theme.primary,
//               padding: '0.8rem',
//               borderRadius: '50px',
//               fontWeight: 500,
//               cursor: 'pointer',
//               transition: 'all 0.25s'
//             }}
//           >
//             Details
//           </button>

//           <button
//             onClick={() => addToCart(product)}
//             style={{
//               flex: 1,
//               background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
//               color: '#111',
//               border: 'none',
//               padding: '0.8rem',
//               borderRadius: '50px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.25s'
//             }}
//           >
//             Add to Cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }